// src/components/lesson/VerifiedBadge.tsx
//
// The "Expert-verified" mark. Renders ONLY when a human has passed the lesson's
// review checklist (Lesson.reviewedAt is set — src/lib/learn/lesson-review.ts).
// One component for the lesson page and the /learn step cards, so the mark
// means the same thing everywhere and cannot be faked by a prop that says so.

import { ShieldCheck } from 'lucide-react'
import { isExpertVerified } from '@/lib/learn/lesson-review'

export default function VerifiedBadge({
  reviewedAt,
  compact = false,
}: {
  /** Lesson.reviewedAt, serialised. Null/undefined renders nothing. */
  reviewedAt: string | null | undefined
  /** The small chip for cards; the default is the lesson-page meta chip. */
  compact?: boolean
}) {
  if (!isExpertVerified({ reviewedAt })) return null
  const date = new Date(reviewedAt!)
  const when = Number.isNaN(date.getTime())
    ? ''
    : ` on ${date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' })}`
  return (
    <span
      className={
        compact
          ? 'inline-flex items-center gap-1 rounded-full bg-emerald-500/15 px-1.5 py-0.5 text-[11px] text-emerald-700 dark:text-emerald-300'
          : 'inline-flex items-center gap-1 rounded-full border border-emerald-500/40 bg-emerald-500/10 px-2.5 py-1 text-emerald-700 dark:text-emerald-300'
      }
      title={`Reviewed by a person${when}: worked examples, pitfalls and the mini-check all checked.`}
      data-testid="verified-badge"
    >
      <ShieldCheck className="h-3 w-3" aria-hidden="true" />
      Expert-verified
    </span>
  )
}
